export const QuillConfiguration = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        ['link'],
        ['image'],  // Add the 'image' option for inserting images
        ['video'],  // Add the 'video' option for inserting videos
        ['formula'],  // Add the 'formula' option for mathematical formulas
        ['align'],  // Add the 'align' option for text alignment
        [{ script: 'sub' }, { script: 'super' }],  // Subscript and Superscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        ['indent', { direction: 'rtl' }],  // Right-to-left text direction
        ['clean'],
    ]

}